import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.16107 6.49408C3.48651 6.16864 4.01414 6.16864 4.33958 6.49408L9.58366 11.7382L14.8277 6.49408C15.1532 6.16864 15.6808 6.16864 16.0062 6.49408C16.3317 6.81951 16.3317 7.34715 16.0062 7.67259L10.1729 13.5059C9.84748 13.8314 9.31984 13.8314 8.9944 13.5059L3.16107 7.67259C2.83563 7.34715 2.83563 6.81951 3.16107 6.49408Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}